import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, { useState } from "react";

const headers = [
  {
    key: "import_code",
    name: "Import Code",
  },
  {
    key: "import_date",
    name: "Import Date",
  },
  {
    key: "warehouse_name",
    parent: "warehouse",
    name: "Warehouse Name",
  },
  {
    key: "product_detail_count",
    name: "Number of Products",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "import_code",
    name: "Import Code",
  },
  {
    key: "warehouse_name",
    parent: "warehouse",
    name: "Warehouse Name",
  },
  {
    key: "import_date",
    name: "Import Date",
  },
  {
    key: "remark",
    name: "Remark",
  },
];

const detailPopupTableHeaders = [
  { name: "Product Name", key: "product_name", parent: "productDetails" },
  { name: "Barcode", key: "barcode", parent: "productDetails" },
  { name: "Quantity", key: "quantity" },
  { name: "SKU", key: "unit_name", parent: "unitDetails" },
];

const StockImportManualList = () => {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/stock-import",
    defaultQuery: "status=ACTIVE",
    included: false,
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      setSearchValue(trimmed);
      setQuery({ search: trimmed });
    } else {
      setSearchValue("");
      setQuery({});
    }
  };

  const results = data?.results || [];

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(results) && results.length === 0;

  return (
    <TableLayout
      title="Stock Import (Manual) List"
      data={data}
      headers={headers}
      detailPopupTitle="Stock Import Information"
      detailPopupStock={true}
      detailPopupHeaders={detailPopupHeaders}
      detailPopupTableHeaders={detailPopupTableHeaders}
      detailPopupTableKey="importDetails"
      detailFetchPath="/stock-import"
      detailFetchIdKey="stock_import_id"
      removeDetails={false}
      idKey="stock_import_id"
      endPoint="/stock-import"
      setCurrentPage={setCurrentPage}
      removeEdit={true}
      //hasSearch
      hasCreate
      hasActions
      module="Warehouse"
      subModule="Stock Import"
      createPath={`/warehouse/stock-import/list/create`}
      currentPath={currentPath}
      //onSearch={handleSearch}
      disabledSerial
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
};

export default StockImportManualList;
